/* global define */
define('admanager',[
    'jquery',
    'underscore',
    'pubsub',
    'state',
    'utils',
    'user-manager',
    'managers/cachemanager',
    'partner/ad-slot',
    'modules/global/barrier',
    'adLogger',
    'abtest-manager',
    'modules/global/ad-free-redirect',
    'third-party-apis/firefly/firefly',
    'cookie'
],
function(
    $,
    _,
    PubSub,
    StateManager,
    Utils,
    UserManager,
    CacheManager,
    AdSlot,
    Barrier,
    AdLogger,
    AbTestManager,
    AdFreeRedirectCard,
    Firefly
) {
    'use strict';
    /**
     * @exports admanager
     */
    var AdManager = function(){
        this.initialize();
    };

    AdManager.prototype = {

        adSizes : {
            'elastic' : [1080,810],
            'gravity' : [2560,1440],
            'fluid': 'fluid',
            'mediumrectangle' : [300,250],
            'halfpage' : [300,600],
            'portrait': [300,1050],
            'leaderboard' : [728,90],
            'generic': [1,2],
            'billboard': [970,250],
            'sponsor_logo': [100,30],
            'sponsor_logo_medium': [100,50]
        },
        defers: {},
        pageTargetingKeys: [],
        firstBids: true,
        ssInfo: 'NA',
        userStatusDefer: $.Deferred(),
        gspTargetingDefer: $.Deferred(),
        spDeferred: $.Deferred(),
        spReady: $.Deferred(),

         /**
         * Kickoff
         */
        initialize :  function() {
            AdLogger.logInfo('AdManager:: AdManager initialize');
            if (this.isAdFreeExperience()) {
                AdLogger.logInfo('AdManager:: Ads Disabled');
                if (this.scrollUser || this.premiumPlusExperience) Utils.get('body').addClass('is-scroll-user');

                // not going to end up loading sourcepoint, let's fire their beacon
                this.fireSourcepointBeacon();
                return;
            }

            window.googletag = window.googletag || {};
            window.googletag.cmd = window.googletag.cmd || [];

            // Get the U.S. Privacy String
            if(typeof window.__uspapi === 'function') {
                window.__uspapi('getUSPData', 1, _.bind(function (res) {
                    var uspString = res.uspString;
                    this.uspString = uspString;
                    if (uspString === '1YYY') {
                        this._setPageTargeting({'privacy': 'ccpa-out'});
                    }
                }, this));
            } else {
                this.uspString = '1---';
            }

            this.pubSub = {
                'page:load': this._onPageLoad,
                'page:unload': this._onPageUnload,
                'page:beforeReveal': this._preFetchBids,
                'user:statuschange': this._onUserStatusChange,
                'activePageInfo:set': this._onActivePageInfoSet,
                'advertising:defined': this._setupAdSlots,
                'advertising:resolvedefer': this._resolveDefer
            };
            PubSub.attach(this.pubSub, this);

            _.bindAll(this, '_apsLoaded', '_windowVisibilityChange', '_fetchAPS', '_fetchIAS', '_fetchINX', '_fetchPrebid', '_apsBidBack', '_iasBack', '_iasLoaded', '_inxBidBack', '_prebidBidBack', '_resolveDefer', '_preFetchBids', 'loadSoucepoint');
            window.adManager = this;

            StateManager.registerVisibilityListener('admanager', this._windowVisibilityChange, true);

            this._resetSlots();
            this.spDeferred.done(this.loadSoucepoint).fail(this.fireSourcepointBeacon);

            // Set up GPT
            this._setupGoogletag();

            // Set up other 3rd parties
            this.apsLoaded = $.Deferred();
            window.pbjs = window.pbjs || {};
            window.pbjs.que = window.pbjs.que || [];
            this._setUpPrebid();
            window.headertag = window.headertag || {};
            window.headertag.cmd = window.headertag.cmd || [];
            _.each(['aps', 'ias', 'inx_universal', 'prebid'], _.bind(function(partner) {
                this._setupPartner(partner);
            }, this));
            this._preFetchBids($('body'));

            this.marketingTargetBarrier = new Barrier();
            this.marketingTargetBarrier.add(this.userStatusDefer);
            this.marketingTargetBarrier.add(this.gspTargetingDefer);
            this.lng = this._getUserStatus();

            if (Utils.getNested(window, 'site_vars', 'ADS', 'google_pts', 'enabled') && Utils.getNested(window, 'privacyConfig', 'targeting') !== false) {
                this._getPtSScore();
            } else {
                this.user_gsp = '';
            }
        },

        onScriptFail: function(partner) {
            this.adBlockEnabled = true;
            this.spDeferred.resolve();

            PubSub.trigger('advertising:resolvedefer', partner);
            AdLogger.logError('AdManager:: ' + partner + ' not loaded');
        },

        /**
         * This functions checks if the page has an ad blocker enabled
         */
        adBlockDivTest: function () {
            var testDiv = document.createElement('div'),
                container = document.body;
            testDiv.className = 'ad-slot playAds1 leaderboard-container partner';
            testDiv.style.cssText = 'position:absolute;top:-9999px;left:-9999px;width:2px;height:2px';
            container.appendChild(testDiv);
            var bcr = testDiv.getBoundingClientRect();
            this.adBlockEnabled = bcr.top === 0 && bcr.bottom === 0 && bcr.width === 0 && bcr.height === 0;
            container.removeChild(testDiv);

            return this.adBlockEnabled;
        },

        loadSoucepoint: function () {
            if(!window._sp_) {
                AdLogger.logInfo('Loading Sourcepoint');
                require(['third_party_integrations/sourcepoint/sourcepoint-utils'], this.spReady.resolve);
            } else {
                this.fireSourcepointBeacon();
            }

            AdLogger.logInfo('Loading Blockthrough');
            var blockThrough = Utils.getNested(window.site_vars, 'ADS', 'blockThrough');
            if ((blockThrough.enabled ||  Utils.getUrlParam('blockThrough')) && blockThrough.scriptUrl) {
                Utils.requireSingleUseScript(blockThrough.scriptUrl);
            }
        },

        /**
         * This functions fires a script and a generates a pixel as per ADREV-2138 when source point is not loaded on the page
         */
        fireSourcepointBeacon: function () {
            AdLogger.logInfo('Firing Sourcepoint Beacon');
            var sp_tracking_url = 'https://sp.' + window.site_vars.base_url + '/mms/get_site_js?v=1&account_id=308&abp=false&referrer=&session_referrer=&session_message_count=1&jv=2.0.1110&cdc=window._sp_.msg._internal.cdc1&href=' + location.href;
            Utils.requireSingleUseScript(sp_tracking_url);

            var caesarShift = function(str, amount) {
                if (amount < 0)
                    return caesarShift(str, amount + 26);
                var output = '';
                for (var i = 0; i < str.length; i++) {
                    var c = str[i];
                    if (c.match(/[a-z]/i)) {
                        var code = str.charCodeAt(i);
                        if (code >= 65 && code <= 90) {
                            c = String.fromCharCode(((code - 65 + amount) % 26) + 65);
                        } else if (code >= 97 && code <= 122) {
                            c = String.fromCharCode(((code - 97 + amount) % 26) + 97);
                        }
                    }
                    output += c;
                }

                return output;
            };

            var sp_beacon_start = 'https://www.summerhamster.com/bcn?',
                sp_pre_cipher = 'cb=1576077515548&v=2.0.1110&bid=1993252&cid=308&u=' + location.href + '&sntl=1&abl=0&er=0&d2=1%3X%3X1%3X%3X0%3X%3X0%3X%3X1',
                sp_post_cipher = caesarShift(sp_pre_cipher,3),
                sp_beacon_pixel = new Image();
            sp_beacon_pixel.src = sp_beacon_start + sp_post_cipher + '&requestUUID=5a6c0b29-b4dd-42db-9cae-6d30bb369176-1576077511066';
        },

        _getPtSScore: function() {
            this.user_gsp = $.cookie('user_gsp');
            if(!(this.user_gsp || this.lng['ret-sub'])) {
                var dfp = Utils.getNested(window, 'site_vars', 'ADS', 'DFP') || {},
                    accId = Utils.getUrlParam('usatai') || dfp.ACCOUNTID,
                    iu = encodeURIComponent("/" + accId + "/swg/pts_" + dfp.ACCOUNTNAME),
                    sz = encodeURIComponent("1x1"),
                    ref = encodeURIComponent(document.referrer),
                    gadsvalue = encodeURIComponent($.cookie('__gads')),
                    c = Math.floor(Math.random()*1e15),
                    tz = -(new Date().getTimezoneOffset()),
                    adTag = "https://pubads.g.doubleclick.net/gampad/adx?iu=" + iu + "&sz=" + sz + "&ref=" + ref + "&cookie=" + gadsvalue + "&c=" + c + "&tile=1&u_tz=" + tz;

                $.ajax({
                    url : adTag,
                    type : 'GET',
                    dataType: 'json',
                    context : this,
                    xhrFields: {
                        withCredentials: true
                    },
                    success : function(data) {
                        this.user_gsp = data.value;
                        $.cookie('user_gsp', this.user_gsp, {expires: 30, path: '/', secure: true, sameSite: 'None'});
                        window.googletag.cmd.push(_.bind(function () {
                            window.googletag.pubads().setTargeting('user_gsp', this.user_gsp + '');
                        }, this));
                        Utils.logAction('propensitySubscribe', {
                            value: data.value,
                            error: ''
                        });
                    },
                    error : function(req, err) {
                        Utils.logAction('propensitySubscribe', {
                            value: -1,
                            error: err 
                        });
                    },
                    complete: function() {
                        this.gspTargetingDefer.resolve();
                    }
                });
            } else {
                this.gspTargetingDefer.resolve();
            }
        },

        stop: function() {
            PubSub.unattach(this.pubSub, this);
        },

        _onPageLoad: function(pageInfo){
            AdSlot.prototype.pageLoad();
        },

        _onPageUnload: function(){
            AdSlot.prototype.pageUnload();
            // Update our page correlator
            window.googletag.cmd.push(function() {
                AdLogger.logInfo('AdManager: Setting new correlator value');
                window.googletag.pubads().updateCorrelator();
            });
            clearTimeout(this.inxTO);
            clearTimeout(this.iasTO);
            this._resetSlots();
            this._resetPageTargeting();
        },

        _onActivePageInfoSet: function (pageInfo) {
            var pageTargeting = this.pageTargeting = this._getPageTargeting(pageInfo);
            this._setPageTargeting(pageTargeting);
            this._markTargeting(pageTargeting);
            this._setExclusionTargeting(pageInfo);
            this._setSimpleTargeting();

            window.headertag.cmd.push(_.bind(function () {
                window.headertag.setSiteKeyValueData( {
                    topic: pageTargeting.ssts_topic,
                    section: pageTargeting.ssts_section,
                    subsection: pageTargeting.ssts_subsection,
                    brandSafety: this.getBrandSafety(),
                    domain: Utils.getNested(window.site_vars, 'site_key')
                });
            }, this));

            // Disable sourcepoint on sponsored stories
            if(pageInfo.ssts && pageInfo.ssts.indexOf('sponsor-story') > -1) {
                this.spDeferred.reject();
            }

            window.addEventListener('message', function(e) {
                var matches, player,
                    data = e.data;
                if(typeof data === 'string') {
                    matches = data.match(/^(snow-player\/\d*)\/video\/ready$/);
                    if(matches) {
                        player = document.getElementsByName(matches[1])[0];
                        if(player) {
                            player.contentWindow.postMessage(pageTargeting, '*');
                        }
                    }
                }
            }, false);
        },

        isAdFreeExperience: function() {
            var pageInfo = StateManager.getActivePageInfo() || {};
            this.noAds = this.noAds || Utils.getUrlParam('no_ads');
            this.scrollUser = Utils.getNested(window, 'site_vars', 'ADS', 'scroll', 'enabled') && $.cookie('scroll0');
            this.hasPII = this.hasPII || Utils.checkForEmail(document.location.href);
            this.premiumPlusExperience = this.checkForPremiumLicenseType();
            return this.noAds || this.scrollUser || this.hasPII || this.premiumPlusExperience || pageInfo.adsEnabled === false;
        },

        checkForPremiumLicenseType: function () {
            var gupUserInfo;
            try {
                 gupUserInfo = JSON.parse(window.localStorage.getItem('gupUserInfo'));
            } catch(e) {
                // gupUserInfo not a json string
            }
            var adFreeEntitlements =  Utils.getNested(window, 'site_vars', 'ad_free_entitlements');
            var licenseType = Utils.getNested(gupUserInfo, 'response', 'user', 'userLicenseType');
            if (adFreeEntitlements && adFreeEntitlements.indexOf(licenseType) > -1) {
                return true;
            }

            var userAccount = UserManager.getAccount('firefly');
            if (userAccount) {
                userAccount.getUserInfo().always(_.bind(function (userInfo) {
                    if (userInfo && userInfo !== "Not logged in." && adFreeEntitlements.indexOf(userInfo.userLicenseType) > -1) {
                        this._setupAdFreeRedirectSubview();
                    }
                }, this));
            }
            return false;
        },

        _setupAdFreeRedirectSubview: function() {
            this.subviews.adFreeRedirectCard = new AdFreeRedirectCard();
        },

        _setupGoogletag: function () {
            Utils.loadScript('https://securepubads.g.doubleclick.net/tag/js/gpt.js', 'googletag').then(_.bind(this._onGoogletagLoaded, this)).fail(_.bind(this.onScriptFail, this));
        },

        /**
         * Configures the Google services
         * @private
         */
        _onGoogletagLoaded: function() {
            window.googletag.cmd.push(_.bind(function() {
                var pubads = window.googletag.pubads();
                pubads.setTagForChildDirectedTreatment(0);
                pubads.collapseEmptyDivs();
                pubads.enableSingleRequest();
                window.googletag.enableServices();

                var gup_anonid = $.cookie('gup_anonid') || '';
                if (gup_anonid) {
                    pubads.setPublisherProvidedId(gup_anonid);
                }

                // Wait for user status to be determined before sourcepoint
                this.userStatusDefer.then(_.bind(function() {
                    if(this.adBlockDivTest()) {
                        this.spDeferred.resolve();
                    } else {
                        this.spDeferred.reject();
                    }
                }, this));
            }, this));
        },

        _setupPartner: function (partner) {
            var partnerConfig;
            if(this.partnerEnabled(partner)) {
                var index = Utils.getNested(window.site_vars, 'ADS', 'prebid', 'index') || {};

                // Setup Index Exchange Identity Library
                if(partner === 'prebid' && (index.enabled || Utils.getUrlParam('pb_debug') === 'index') && index.identity_lib.scriptUrl){
                    Utils.requireSingleUseScript(index.identity_lib.scriptUrl);
                }

                partnerConfig = Utils.getNested(window.site_vars, 'ADS', partner);
                Utils.loadScript(partnerConfig.scriptUrl, partnerConfig.symbol).then(this['_' + partner + 'Loaded']).fail(_.bind(function() {
                        this.onScriptFail(partner);
                    }, this));
            }
        },

        partnerEnabled: function(partner) {
            // TODO Rip out once we get rid of inx_universal
            if(partner === 'inx_universal') {
                var index = Utils.getNested(window.site_vars, 'ADS', 'prebid', 'index') || {};
                if(index.enabled || Utils.getUrlParam('pb_debug') === 'index') {
                    return false;
                }
            }
            this[partner + 'IsEnabled'] = this[partner + 'IsEnabled'] || Utils.getNested(window.site_vars, 'ADS', partner, 'enabled') === true || Utils.getUrlParam(partner + '_debug');
            return this[partner + 'IsEnabled'];
        },

        _preFetchBids: function($context) {
            var pageInfo = StateManager.getActivePageInfo(),
                overrides = this.getOverrides();
            _.each($('.partner-placement[data-ad-sizes]', $context), function(el) {
                var $el = $(el),
                    data = $el.data(),
                    subSection = (pageInfo.cst) ? '/' + pageInfo.cst : '',
                    baseAdUnit = data.adPlacement + subSection,
                    adUnit = AdSlot.prototype.buildAdUnit(baseAdUnit, overrides),
                    slotId = data.slotId || _.uniqueId('ad-slot-' + adUnit.replace(/\//g, '-') + '-');

                // set the slotId on the el, so AdSlot can reference the same id when the slot is setup
                $el.data('slotId', slotId);
                AdSlot.prototype.configurePrebidSlot(adUnit, data.adSizes, slotId, $el);
                AdSlot.prototype.configureAPSSlot(data.adSizes, slotId, $el);
                AdSlot.prototype.configureINXSlot(data.adPlacement, data.adSizes, slotId, $el);
                AdSlot.prototype.configureIASSlot(adUnit, data.adSizes, slotId, $el);
            });
            if (pageInfo.videoincluded) {
                _.each($('.js-teal-player', $context), function(el, i) {
                    var $el = $(el),
                        slotId = 'video-slot' + i;
                    try {
                        $el.data(JSON.parse(el.getElementsByClassName('ui-video-placement-data')[0].innerHTML));
                    } catch(e) {
                        // video placement data is empty
                    }
                    $el.data('slotId', slotId);
                    AdSlot.prototype.configureVideoPrebidSlot($el);
                });
            }

            this._fetchPrebid();
            this._fetchAPS();
            this._fetchINX();
            this._fetchIAS();
        },

        _setUpPrebid: function () {
            var prebid = Utils.getNested(window.site_vars, 'ADS', 'prebid') || {},
                config = prebid.config || {},
                staq = prebid.staq || {},
                liveintent = prebid.liveintent || {},
                identityLink = prebid.identityLink || {};

            window.pbjs.que.push(function() {
                var priceBrackets = {
                        buckets : [{
                            precision: 2,
                            min: 0,
                            max: 10,
                            increment: 0.01
                        },
                        {
                            precision: 2,
                            min: 10,
                            max: 20,
                            increment: 0.05
                        },
                        {
                            precision: 2,
                            min: 20,
                            max: 50,
                            increment: 0.10
                        },
                        {
                            precision: 2,
                            min: 50,
                            max: 75,
                            increment: 0.25
                        },
                        {
                            precision: 2,
                            min: 75,
                            max: 100,
                            increment: 0.50
                        },
                        {
                            precision: 2,
                            min: 100,
                            max: 200,
                            increment: 1.00
                        },
                        {
                            precision: 2,
                            min: 200,
                            max: 480,
                            increment: 5.00
                        }]
                    };

                // Set prebid config options, fallbacks are prebid defaults
                var userIds = [],
                    options = {
                        consentManagement: {
                            usp: {
                                cmpApi: 'iab',
                                timeout: config.uspapiTimeout || 0
                            }
                        },
                        priceGranularity: priceBrackets,
                        enableSendAllBids: false,
                        maxRequestsPerOrigin: config.maxRequestsPerOrigin || 4,
                        timeoutBuffer: config.timeoutBuffer || 200,
                        userSync: {
                            syncEnabled: true,
                            filterSettings: {
                                iframe: {
                                    bidders: config.syncBlacklistIframe || [],
                                    filter: 'exclude'
                                },
                                image: {
                                    bidders: config.syncBlacklistImage || [],
                                    filter: 'exclude'
                                }
                            },
                            syncsPerBidder: config.syncsPerBidder || 5,
                            syncDelay: config.syncDelay || 5000
                        },
                        useBidCache: !!config.useBidCache
                    };

                if (liveintent.enabled || Utils.getUrlParam('liveintent')) {
                    userIds.push({
                        name: "liveIntentId",
                        params: {
                            publisherId: liveintent.publisherId,
                            identifiersToResolve: ['gup_anonid']
                        },
                        storage: {
                            type: 'cookie',
                            name: 'pbjs_li_nonid',
                            expires: 1
                        }
                    });
                }

                if (identityLink.enabled || Utils.getUrlParam('identitylink')) {
                    userIds.push({
                        name: 'identityLink',
                        params: {
                            pid: identityLink.placementId
                        },
                        storage: {
                            type: 'cookie',
                            name: 'idl_env',
                            expires: 7
                        }
                    });
                }

                if (userIds.length) options.userSync.userIds = userIds;

                window.pbjs.setConfig(options);

                //Enable analytics for prebid adapter
                if(staq.enabled) {
                    window.pbjs.enableAnalytics([{
                        provider: 'staq',
                        options: {
                            host: document.location.hostname,
                            url: staq.url,
                            connId: staq.connId
                        }
                    }]);
                }
            });

            var rivrConfig = Utils.getNested(window.site_vars, 'ADS', 'prebid', 'rivr') || null;

            if (rivrConfig && (rivrConfig.enabled || Utils.getUrlParam('rivr'))){
                this._setupRivr(rivrConfig);
            }
        },

        _prebidLoaded: function() {
            AdLogger.logInfo('Prebid Script Loaded');
        },

        _fetchPrebid: function(slotId) {
            var slots;

            if(this.partnerEnabled('prebid')) {
                if(slotId) {
                    slots = [slotId];
                } else {
                    slots = this.prebidSlots;
                }

                window.pbjs.que.push(_.bind(function() {
                    var requestObj = {
                        timeout: Utils.getNested(window.site_vars, 'ADS', 'prebid', 'timeout') || 1500,
                        adUnitCodes: slots,
                        bidsBackHandler: this._prebidBidBack
                    };

                    if (window.rivraddon && typeof window.rivraddon.adjustRequest === 'function') {
                        var adjustedRequestedObj = window.rivraddon.adjustRequest(requestObj);
                        window.pbjs.requestBids(adjustedRequestedObj);
                    } else {
                        window.pbjs.requestBids(requestObj);
                    }

                    AdLogger.logInfo('AdManager:: Fetching slot prebid', slots);
                }, this));

                // Clear the slots after the first batched request
                this.prebidSlots = [];
                this.prebidSlots.push = this._fetchPrebid;
            } else {
                PubSub.trigger('advertising:resolvedefer', 'prebid');
            }
        },

        _setupRivr: function(rivrConfig) {
            Utils.loadScript(rivrConfig.scriptUrl, 'rivraddon').then(function () {
                window.pbjs.que.push(function() {
                    var args = {
                        clientID: rivrConfig.clientId,
                        authToken: rivrConfig.clientAuthToken,
                        pbjs: window.pbjs
                    };
                    if (window.rivraddon) {
                        window.rivraddon.enable(args);
                    } else {
                        window.RIVR_ARGS = args;
                    }
                });
            });
        },

        _prebidBidBack: function(event) {
            this.slotCreationBarrier.wait().done(_.bind(function() {
                window.googletag.cmd.push(_.bind(function () {
                    if(event) {
                        var slots = window.googletag.pubads().getSlots();
                        // Set targeting and resolve defers
                        AdLogger.logInfo('AdManager:: Setting winning bid for Prebid');
                        _.each(slots, function(slot) {
                            var bids = (event[slot.getSlotElementId()] || {bids: []}).bids;
                            if(bids.length) {
                                var winningBid = this._getWinningBid(bids),
                                    code = Utils.getNested(winningBid, 'bidderCode'),
                                    adPointId = Utils.getNested(window.site_vars, 'ADS', 'prebid', code, 'adPointId') || null;

                                if (window.newrelic && adPointId === null) {
                                    window.newrelic.addPageAction('advertisingError', {
                                        message: 'AdPoint ID not found in config for bidder code: ' + code,
                                        build: 'legacy desktop'
                                    });
                                    return;
                                }

                                // Set custom AdPoint targeting
                                slot.setTargeting('hb_ap', winningBid.adserverTargeting.hb_pb);
                                slot.setTargeting('hb_ap_id', adPointId);

                                // Set other generic targeting values (only those enabled in config)
                                _.each(winningBid.adserverTargeting, function(value, key) {
                                    if(this._validPBKey(key)) {
                                        slot.setTargeting(key, value);
                                    }
                                }, this);
                            }
                        }, this);
                        PubSub.trigger('advertising:prebidback', event);

                    }
                    PubSub.trigger('advertising:resolvedefer', 'prebid');
                }, this));
            }, this));
        },

        _getWinningBid: function(bids) {
            return bids.filter(function(bid) {
                var floor = Utils.getNested(window.site_vars, 'ADS', 'prebid', bid.bidderCode, 'floor') || 0;
                return bid.cpm >= floor;
            }).sort(function(a, b) {
                return a.cpm - b.cpm;
            }).pop();
        },

        _validPBKey: function(key) {
            var config = Utils.getNested(window.site_vars, 'ADS', 'prebid', 'targeting') || {},
                validKeys = config.keys || ['adid', 'deal'],
                re = new RegExp('_(' + validKeys.join('|') + ')');
            return (key.match(re) && key.match(re).length);
        },

        _apsLoaded: function () {
            var debugMode = Utils.getNested(window.site_vars, 'ADS', 'aps', 'debug') || 'disable',
                options = {
                    pubID: Utils.getNested(window.site_vars, 'ADS', 'aps', 'pubID'),
                    adServer: 'googletag',
                    bidTimeout: Utils.getNested(window.site_vars, 'ADS', 'aps', 'timeout') || 1500,
                    videoAdServer: 'DFP',
                    params: {
                        us_privacy: this.uspString
                    }
                };

            window.apstag.debug(debugMode);
            window.apstag.init(options);

            this.apsLoaded.resolve();
        },

        _fetchAPS: function (slot) {
            var slots = (slot) ? [slot] : this.apsSlots;

            if(this.partnerEnabled('aps')) {
                this.apsLoaded.then(_.bind(function() {
                    if(window.apstag && slots && slots.length) {
                        window.apstag.fetchBids({
                            slots: slots
                        }, this._apsBidBack);

                        // Have any further push commands fire off a fetch with the individual slot
                        this.apsSlots.push = this._fetchAPS;
                    } else {
                        PubSub.trigger('advertising:resolvedefer', 'aps');
                        AdLogger.logInfo('AdManager:: APS not loaded');
                    }
                }, this));
            } else {
                PubSub.trigger('advertising:resolvedefer', 'aps');
            }
        },

        _apsBidBack: function (bids) {
            this.slotCreationBarrier.wait().done(function() {
                window.googletag.cmd.push(function () {
                    window.apstag.setDisplayBids();
                    AdLogger.logInfo('AdManager:: Setting APS targeting', bids);
                    PubSub.trigger('advertising:resolvedefer', 'aps');
                });
            });
        },

        _fetchIAS: function(slot) {
            var id = Utils.getNested(window.site_vars, 'ADS', 'ias', 'pubid'),
                slots = (slot) ? [slot] : this.iasSlots;
            if(id && this.partnerEnabled('ias')) {
                window.__iasPET = window.__iasPET || {};
                window.__iasPET.queue = window.__iasPET.queue || [];
                window.__iasPET.pubId = id;

                window.__iasPET.queue.push({
                    adSlots: slots,
                    dataHandler: this._iasBack
                });

                this.iasTO = setTimeout(function() {
                    PubSub.trigger('advertising:resolvedefer', 'ias');
                }, Utils.getNested(window.site_vars, 'ADS', 'ias', 'timeout') || 1000);

                this.iasSlots.push = this._fetchIAS;
            } else {
                PubSub.trigger('advertising:resolvedefer', 'ias');
            }
        },

        _iasLoaded: function() {
            var scriptUrl = Utils.getNested(window.site_vars, 'ADS', 'ias', 'adxScriptUrl') || 'https://static.adsafeprotected.com/iasADX.js';
            Utils.requireSingleUseScript(scriptUrl).then(function() {
                window.__iasADX.start(Utils.getNested(window.site_vars, 'ADS', 'ias', 'pubid'));
            });
        },

        _iasBack: function() {
            this.slotCreationBarrier.wait().done(function() {
                window.googletag.cmd.push(function () {
                    window.__iasPET.setTargetingForGPT();
                    PubSub.trigger('advertising:resolvedefer', 'ias');
                });
            });
        },

        _fetchINX: function (slot, prefetch) {
            var slots = (slot) ? [slot] : this.inxSlots,
                timeout = Utils.getNested(window.site_vars, 'ADS', 'inx_universal', 'timeout') || 1000;
            if(this.partnerEnabled('inx_universal')) {
                // Map duplicate-free array of slot names to htSlotName objects
                window.headertag.cmd.push(_.bind(function () {
                    var inxSlots = _.chain(slots).pluck('name').uniq().map(function(name) { return { htSlotName: name }; }).value();
                    window.headertag.retrieveDemand(inxSlots, this._inxBidBack);
                }, this));
                this.inxTO = setTimeout(function() {
                    PubSub.trigger('advertising:resolvedefer', 'inx');
                },  timeout);
                this.inxSlots.push = this._fetchINX;
            } else {
                PubSub.trigger('advertising:resolvedefer', 'inx');
            }
        },

        _inxBidBack: function(demand) {
            // Wait till our slots are setup, if INX returned beforehand
            this.slotCreationBarrier.wait().done(_.bind(function() {
                if(demand) {
                    window.googletag.cmd.push(_.bind(function() {
                        var pubads = window.googletag.pubads(),
                            slots = pubads.getSlots();
                        if(demand.slot && slots.length) {
                            _.each(demand.slot, function(bids, slotName) {
                                var inxUnit = _.findWhere(this.inxSlots, {name: slotName});
                                if(inxUnit && inxUnit.slotId) {
                                    var gptSlot = _.find(slots, function(slot) {
                                        return slot.getSlotElementId() === inxUnit.slotId;
                                    });
                                    if(bids.length && gptSlot) {
                                        _.each(bids, function(bid) {
                                            _.each(bid.targeting, function(value, key) {
                                                // Set the targeting on the slot
                                                gptSlot.setTargeting(key, value);
                                            });
                                        });
                                    }
                                }
                            }, this);
                        }
                        if(demand.page && demand.page.length) {
                            this._setPageTargeting(demand.page);
                        }
                    }, this));
                }

                PubSub.trigger('advertising:resolvedefer', 'inx');
            }, this));
        },

        _setPageTargeting: function(targeting) {
            window.googletag.cmd.push(_.bind(function() {
                var pubads = window.googletag.pubads();
                _.each(targeting, function(value, key) {
                    if (!(typeof value === 'undefined' || value === null || value === '' || (_.isArray(value) && !value.length))) {
                        value = Utils.scrubEmail(value);
                        this.pageTargetingKeys.push(key);
                        pubads.setTargeting(key, value);
                    }
                }, this);
                AdLogger.logInfo('AdManager:: set page level targeting', targeting);
            }, this));
        },

        _resetPageTargeting: function() {
            window.googletag.cmd.push(_.bind(function() {
                this.pageTargetingKeys.forEach(function(key){
                    window.googletag.pubads().clearTargeting(key);
                });

                this.pageTargetingKeys = [];
            }, this));
        },

        /**
         * Gets the page level targeting object
         * @private
         */
        _getPageTargeting: function(pageInfo){
            var getNested = Utils.getNested,
                siteName = getNested(window, 'site_vars', 'aws_site_name') || 'usat',
                cstParts = (getNested(pageInfo, 'cst') || '').split('/'),
                ssts = getNested(pageInfo, 'ssts') || '',
                sstsParts = ssts.split('/'),
                navigationtype = Utils.getUrlParam('navigationtype') || this._getNavigationType(pageInfo.refreshed),
                breaking = getNested(pageInfo, 'breaking'),
                alerttype = (breaking) ? 'breaking': (breaking === false) ? 'none': '',
                userInsights = this._getUserInsights(),
                doLookALike = (userInsights.doLookALike !== undefined) ? userInsights.doLookALike.toString() : '',
                buildType = (getNested(pageInfo, 'layout_type') === 'front-list-sidebar-page') ? 'dfr' : 'legacy desktop',
                viewCount = this._getMeterViews();

            return {
                aam_props: 'reimagine|desktop|' + pageInfo.contenttype, // Omniture props 26|4|16
                variant: getNested(pageInfo, 'user', 'abTest', 'userVariant', 'id') || '',
                variant_p: getNested(pageInfo, 'prevPageInfo', 'user', 'abTest', 'userVariant', 'id') || '',
                sgrp: AbTestManager.splitTestGroup,
                adlabel: this.getOverrides().adlabel,
                alerttype: alerttype,
                build: buildType,
                contentid: pageInfo.assetid,
                cst_section: cstParts[0] || '',
                cst_subsection: cstParts[1] || '',
                cst_topic: cstParts[2] || '',
                dolookalike: doLookALike,
                features: this._getFeatures(),
                front: this._getLastFront(pageInfo),
                ksg: (localStorage.getItem('kxgannett_segs') || '').split(','),
                kuid: (localStorage.getItem('kxgannett_user') || ''),
                meter: viewCount || '',
                navigationtype: navigationtype,
                origin: (pageInfo.origin || '').replace(/[\/\-_]/g,''),
                pageType: pageInfo.basePageType,
                privacy: (this.uspString === '1YYY') ? 'ccpa-out': 'NA',
                property: siteName,
                referrer: this._getTargetingReferrer(),
                series: pageInfo.series,
                sitepage: siteName + '/' + ssts,
                swgt: this._getPropensitySubscribe(),
                ss: this.ssInfo,
                ssts_section: sstsParts[0] || '',
                ssts_subsection: sstsParts[1] || '',
                ssts_topic: sstsParts[2] || '',
                ssts_subtopic: sstsParts[3] || '',
                topic: pageInfo.topic,
                user_traits: this._getUserTraits(),
                userguid: $.cookie('gup_anonid') || '',
                user_gsp: this.user_gsp,
                utm_props: this._getUtm()
            };
        },

        _getUserTraits: function() {
            var traits = [],
                camEid = $.cookie('gnt_eid') || $.cookie('cam_eid'),
                camExperienceId = Utils.getNested(this._getUserInsights(), 'cam-experience', 'id');

            //Check for caucus segment
            if(camEid) {
                traits.push(camEid);
            }

            // Check for cam experience Id
            if(camExperienceId) {
                traits.push(camExperienceId);
            }

            return traits.filter(function(item, pos) {
                return traits.indexOf(item) === pos;
            });
        },

        _markTargeting: function (targeting) {
            if (!targeting.topic && targeting.pageType === 'story') {
                Utils.logAction('advertisingSuspiciousTargeting', {
                    mediaType: 'display',
                    build: 'legacy desktop',
                    targeting: JSON.stringify(targeting)
                });
            }
        },

        /**
         * Checks for various features that we have available on ad units
         * @return {String} feature that we detected
         * @private
         */
        _getFeatures: function() {
            var features = [],
                overrides = Utils.getUrlParam('features') || '';

            if(overrides) {
                return overrides.split(',');
            }

            if (!!window.chrome) features.push('noautoplay');

            var nav = navigator,
                ni = nav.connection,
                niEffectiveType = ni && ni.effectiveType;

            if (ni && ni.saveData || 
                niEffectiveType && niEffectiveType !== '4g' || 
                nav.deviceMemory < 4 ||
                Utils.getNested(window, 'site_vars', 'ADS', 'videoDisabled') ||
                (!!window.MSInputMethodContext && !!document.documentMode)) {
                features.push('low');
            }

            return (features.length) ? features : '';
        },

        _getMeterViews: function () {
            var viewsCookie = Firefly.getFireflyViewsCookie();
            if (viewsCookie) {
                return viewsCookie.viewCount;
            }
            return null;
        },

        /**
         * Sets the base exclusion targeting based on taxonomy and keywords
         * @private
         */
        _setExclusionTargeting: function(pageInfo) {
            var pageTags,
                keywords = pageInfo.seokeywords || '',
                taxonomy = pageInfo.taxonomykeywords || '',
                categories = Utils.getNested(window, 'site_vars', 'ADS', 'exclusion_categories') || [];

            keywords = (_.isArray(keywords)) ? keywords : keywords.split(',');
            taxonomy = (_.isArray(taxonomy)) ? taxonomy : taxonomy.split(',');
            pageTags = _.map(_.compact(_.union(keywords, taxonomy)), function(str) { return str.toLowerCase().trim(); });

            window.googletag.cmd.push(function() {
                var pubads = window.googletag.pubads();

                // Clear out any previous categories
                pubads.clearCategoryExclusions();

                categories.forEach(function(category) {
                    var tags = _.map(category.tags, function(tag) {
                            return tag.toLowerCase();
                        }),
                        matched = _.intersection(pageTags, tags);

                    if(!_.isEmpty(matched)) {
                        pubads.setCategoryExclusion(category.name);
                    }
                });
            });
        },

        getBrandSafety: function() {
            if(!this.brandSafety) {
                var simpleExclusion = window.simpleExclusion || [],
                    simpleTarget = window.simpleTarget || [];

                this.brandSafety = _.uniq(simpleTarget.concat(simpleExclusion));
            }
            
            return this.brandSafety;
        },

        _setSimpleTargeting: function() {
            window.googletag.cmd.push(_.bind(function() {
                var pubads = window.googletag.pubads();

                _.uniq(window.simpleExclusion || []).forEach(function(tag) {
                    pubads.setCategoryExclusion(tag);
                });

                this._setPageTargeting({categoryvalue: this.getBrandSafety()});
            }, this));
        },

        _getNavigationType: function(isAutoRefresh) {
            var type =  'external';
            if(isAutoRefresh) {
                type =  this.windowIsVisible ? 'pagerefresh-on' : 'pagerefresh-off';
            } else if (StateManager.lastUrl || document.referrer.indexOf(Utils.getNested(window, 'site_vars', 'base_url')) !== -1) {
                type = 'internal';
            } else if (!document.referrer) {
                type =  'direct';
            }
            return type;
        },

        _windowVisibilityChange: function(visible) {
            this.windowIsVisible = visible;
        },

        _getTargetingReferrer: function () {
            // Maps output from StateManager.getReferrer to ad targeting referrer
            var referrerMatches = StateManager.getReferrer().match(/^https?\:\/\/([^\/:?#]+)(?:[\/:?#]|$)/i),
                referrer = referrerMatches && referrerMatches[1];
            if (referrer) {
                // Only return apex domain for referrer (e.g. 'facebook.com')
                referrer = referrer.split('.').slice(-2).join('.');
            } else {
                referrer = 'NA';
            }
            return referrer;
        },

        _getUserInsights: function() {
            var data = {};
            try {
                data = JSON.parse(window.localStorage.getItem('user_insights')) || {};
            } catch(e) {
                // user_insights not a json string
            }
            return data;
        },

        _getUtm: function () {
            var getParam = Utils.getUrlParam,
                source = getParam('itm_source') || getParam('utm_source') || '',
                medium = getParam('itm_medium') || getParam('utm_medium') || '',
                campaign = getParam('itm_campaign') || getParam('utm_campaign') || '';
            return source + '|' + medium + '|' + campaign;
        },

        _getLastFront: function(pageInfo) {
            // Only valid for the next view
            var front = (pageInfo.ssts.indexOf("sponsor-story") !== -1) ? '' : $.cookie('last_front');
            $.removeCookie('last_front', { path: '/' });

            return front;
        },

        _getUserStatus: function() {
            var lastKnown = $.cookie('gup_lng');
            var lng = {};
            
            if(lastKnown) {
                try {
                    lng = JSON.parse(decodeURIComponent(lastKnown));
                    if(lng && lng.auth === false) {
                        if(lng['ret-sub'] === true ) {
                            this.ssInfo = 'sub_off';
                        } else if (lng['ret-usr'] === true) {
                            this.ssInfo = 'reg_off';
                        }
                    }
                } catch(e) {
                    AdLogger.logInfo(e);
                }
            }

            this.userStatusDefer.then(_.bind(function () {
                window.googletag.cmd.push(_.bind(function () {
                    window.googletag.pubads().setTargeting('ss', this.ssInfo);
                }, this));
            }, this));

            return lng;
        },

        _onUserStatusChange: function(accountName, status) {
            if (accountName === 'firefly' &&  (status === 'loggedIn' || status === 'loggingIn')) {
                UserManager.getCoreUserInfo().then(_.bind(function(userData) {
                    if (userData.UserLicenseType) {
                        this.ssInfo = _.map(userData.UserLicenseType.split('_'), function(pair){
                            return pair.substring(0, 3);
                        }).join('_');

                        // Don't load sourcepoint for subscribers
                        this.spDeferred.reject();
                    } else {
                        this.ssInfo = 'reg_no_sub';
                    }
                    this.userStatusDefer.resolve();
                }, this));
            } else if (this.ssInfo === 'NA') {
                this.ssInfo = 'non';
                this.userStatusDefer.resolve();
            }
        },

        subscriberTargetingSet: function() {
            return this.marketingTargetBarrier.wait().then(function() {
                return $.Deferred(function(defer) {
                    defer.resolve();
                });
            });
        },

        getOverrides: function() {
            /* jshint ignore:start */
            return this.overrides = this.overrides || {
                adlabel: [Utils.getUrlParam('usatl')].filter(Boolean),
                account: Utils.getUrlParam('usatai'),
                property: Utils.getUrlParam('usatan')
            };
            /* jshint ignore:end */
        },

        _getPropensitySubscribe: function() {
            var gupUserInfo = {},
                propensitySubscribe,
                result = [];
            try {
                gupUserInfo = JSON.parse(window.localStorage.getItem('gupUserInfo')) || {};
                propensitySubscribe = gupUserInfo.response.propensitySubscribe;

                result = _.filter(_.keys(propensitySubscribe), function(key) {
                    return propensitySubscribe[key];
                });

            } catch(e) {
                // gupUserInfo not a json string
            }

            return (result[0]) ? result[0] : '';
        },

        /**
         * AD SLOT CREATION
         */

        /**
         * Builds an ad slot wrapper around google's ad slots
         * @param {String} adPlacement name of the dfp placement i.e. poster
         * @param {String} adUnit segmented adUnit name i.e. poster/news/politics
         * @param {Object} targeting key/value custom targeting map
         * @param {String[]} exclusion values
         * @param {String[]} rawSizes Ad sizes
         * @param {Object} adPosition Object that will handle the ad slot
         * @param {String} [slotType=out] google slot type, either 'out' or 'in'
         * @param {Boolean} autoRefresh enabled bool
         */
        getAdSlot: function(adPlacement, adUnit, targeting, exclusion, rawSizes, adPosition, slotType, autoRefresh){
            var defer = $.Deferred(),
                options = Utils.getNested(adPosition, 'options') || {},
                adSizes = this._mapAdSizes(rawSizes),
                slot = options.slot && options.slot[0] || adPosition.el,
                slotConfig = {},
                suppressAdSizes = Utils.getNested(AbTestManager.getUserTestByTarget('ad-suppression'), 'userVariant', 'options', 'suppressAdSizes');

            if (this.isAdFreeExperience()) {
                return false;
            }

            // see if we need to suppress any ad placements (generally used for a/b testing)
            if (suppressAdSizes) {
                adSizes = this._suppressAdSizes(adPlacement, adSizes, suppressAdSizes);
            }

            // No ad sizes, we just return
            if(_.isEmpty(adSizes)) {
                return false;
            }

            // give the slot an id, if it doesn't have one yet
            if (!slot.id) {
                slot.id = _.uniqueId('ad-position-');
            }

            this.activeSlotStatistics.unknown++;
            this.slotsBarrier.add(defer, 3000, true);
            defer.done(_.bind(function() {
                // leave failures as unknown
                this.activeSlotStatistics.unknown--;
            }, this));

            slotConfig = {
                adPlacement: adPlacement,
                adUnit: adUnit,
                autoRefresh: autoRefresh,
                exclusion: exclusion,
                targeting: targeting,
                sizes: adSizes,
                type: slotType || 'in',
                position: $(slot),
                adPositionMap: {},
                lazy: !!options.lazy,
                deferred: options.deferred,
                onSlotEmpty: _.bind(function() {
                    this.activeSlotStatistics.noad++;
                    defer.resolve();
                }, this),
                onSlotRender: _.bind(function(adData, adType, adSize) {
                    if (!adType) {
                        if (adSize && adSize[0] === 0 && adSize[1] === 0) {
                            this.activeSlotStatistics.fluid++;
                        } else {
                            this.activeSlotStatistics.iab++;
                        }
                    } else {
                        this.activeSlotStatistics.high_impact++;
                        var ecid = Utils.getNested(adData, 'dfp', 'ecid');
                        this.activeSlotStatistics.high_impact_info.push({
                            'adType': adType,
                            'ecid': ecid,
                            'state' : 'loading'
                        });
                    }
                    defer.resolve();
                }, this),
                defers: {
                    fetch: $.Deferred(),
                    batch: this.defers.batch
                },
                overrides: this.getOverrides()
            };

            // Create a unique key for each possible returned size
            _.each(adSizes, function(adSize) {
                var key = (adSize === 'fluid') ? '0x0' : (slotType === 'out') ? '1x1' : adSize[0] + 'x' + adSize[1];
                slotConfig.adPositionMap[key] = adPosition;
            });

            if(this.queuing) {
                AdLogger.logInfo('AdManager:: Queueing Ad Slot : ' + adPlacement, adSizes);
                this._queueSlot(slot, adSizes, targeting, exclusion, slotConfig);
            } else {
                AdLogger.logInfo('AdManager:: Creating Ad Slot', adPlacement, adSizes);
                this._createAdSlot(slotConfig);
            }
        },

        buildAdUnit: function(adUnit) {
            return AdSlot.prototype.buildAdUnit(adUnit, this.getOverrides());
        },

        _queueSlot: function(slot, adSizes, targeting, exclusion, slotConfig) {
            var thisSlot = this.queuedAdUnits[slot.id];
            if(thisSlot) {
                var sharedSlot = {
                        sizes: _.union(thisSlot.sizes, adSizes),
                        targeting: _.extend({}, thisSlot.targeting, targeting),
                        exclusion: _.union(thisSlot.exclusion, exclusion),
                        adPositionMap:  _.extend(thisSlot.adPositionMap, slotConfig.adPositionMap),
                    };
                // Add in additional sizes, targeting, adPositions to the existing slot
                slotConfig = _.extend({}, thisSlot, sharedSlot);
            }
            this.queuedAdUnits[slot.id] = slotConfig;
        },

        _createAdSlot: function(slotConfig) {
            var newSlot = new AdSlot(slotConfig);

            _.each(slotConfig.adPositionMap, function(adPosition) {
                //set the new adslot as a subview on each ad position
                adPosition.subviews.adSlot = newSlot;
            });

            // save a paired down version of this slotConfig to our active slot statistics
            this.activeSlotStatistics.slots.push({
                adunit : slotConfig.adUnit,
                el: newSlot.el,
                id: newSlot.slotId,
                adSlot: newSlot,
                sizes: slotConfig.sizes
            });
        },

        _setupAdSlots: function() {
            AdLogger.logInfo('AdManager:: Creating Queued Ad Slots', this.queuedAdUnits);

            _.each(this.queuedAdUnits, function(adUnit) {
                this.slotCreationBarrier.add(adUnit.defers.fetch, 500, true);
                this._createAdSlot(adUnit);
            }, this);
            this.queuing = false;
            this.defers.hold.resolve();
        },

        _mapAdSizes: function(adSizes) {
            if(adSizes === 'fluid' || (adSizes.length === 2 && _.isNumber(adSizes[0]))) {
                return [adSizes];
            } else if(_.isArray(adSizes)) {
                return adSizes.map(_.bind(function(size) {
                    if(_.isArray(size)) {
                        return size;
                    }
                    return this.adSizes[size];
                }, this));
            } else {
                // passed a string, just map it
                return [this.adSizes[adSizes]];
            }
        },

        /**
         * Resets the ad manager's slot variables
         * @private
         */
        _resetSlots: function() {
            // reset barriers
            _.each(['slotCreationBarrier', 'slotsBarrier', 'batchBarrier'], this._resetBarrier, this);
            _.each(['aps', 'ias', 'inx', 'prebid'], function(type) {
                var defer = $.Deferred();
                this.defers[type] = defer;
                this.batchBarrier.add(defer, false, true);

                // reset our slot arrays
                this[type + 'Slots'] = [];
            }, this);
            this.defers.batch = $.Deferred();
            this.defers.hold = $.Deferred();
            this.slotCreationBarrier.add(this.defers.hold, false, false);
            this.batchBarrier.wait().done(_.bind(function() {
                // make a last attempt to set userguid
                var userguid = $.cookie('gup_anonid') || '',
                    kuid = localStorage.getItem('kxgannett_user') || '';

                this._setPageTargeting({
                    userguid: userguid,
                    kuid: kuid
                });
                this.defers.batch.resolve();
            }, this));

            this.queuing = true;
            this.queuedAdUnits = {};
            this.activeSlotStatistics = {
                high_impact: 0,
                high_impact_info: [],
                iab: 0,
                noad: 0,
                unknown: 0,
                slots: [],
                fluid: 0
            };
        },

        _resetBarrier: function(barrierName) {
            if (this[barrierName]) {
                this[barrierName].cancel(true);
            } else {
                this[barrierName] = new Barrier();
            }
        },

        _resolveDefer: function(defer) {
            this.defers[defer].resolve();
        },

        /**
         * Returns a promise that will resolve when we are reasonably certain that all the ads have been
         * requested and delivered or the specified timeout has occurred.
         * @returns {Deferred} This deferred will resolve with a map of statistics. ex: { high_impact: 0, iab: 0, noad: 0, unknown: 0 }
         */
        getActiveSlotStatistics: function() {
            if(this.isAdFreeExperience()) {
                return $.Deferred().resolve({});
            } else {
                return this.slotsBarrier.wait().then(_.bind(function() {
                    var slotStatistics = this.activeSlotStatistics;
                    return $.Deferred(function(defer) {
                        _.defer(function() {
                            defer.resolve(slotStatistics);
                        });
                    });
                }, this));
            }
        },

        /**
         * Checks to see if there is an active ad suppression a/b test and, if so, suppresses the defined ad sizes
         * @param {String} adPlacement name of the dfp placement i.e. poster
         * @param {Array} adSizes mapped ad sizes
         * @param {Array<Object>} suppressAdSizes array of ad sizes (placeement and size) to suppress
         * @returns {Array}
         * @private
         */
        _suppressAdSizes: function(adPlacement, adSizes, suppressAdSizes) {
            if (_.isArray(suppressAdSizes) && _.isArray(adSizes)) {
                suppressAdSizes = _.filter(suppressAdSizes, function(suppressAdSize) {
                    return suppressAdSize.adPlacement === adPlacement;
                });
                _.each(suppressAdSizes, function (suppressAdSize) {
                    _.each(adSizes, function (adSize, i) {
                        if (_.isEqual(suppressAdSize.adSize, adSize)) {
                            adSizes.splice(i,1);
                        }
                    });
                });
            }
            return adSizes;
        },

        /**
         * High impact adunits rely on this function, just mapping it directly to adlogger
         */
        logDebug: AdLogger.logDebug

    };

    return new AdManager();
});

define('api/ads', ['jquery', 'admanager'], function($, AdManager) {
    'use strict';
    return {
        registerAd: function(domId, adUnit, adSizes, targetingObj) {
            var $el = typeof domId === 'string' ? $('#' + domId) : $(domId),
                adPlacement = adUnit.split('/')[0],
                adPosition = {
                    $el: $el,
                    render: function(adData, adType){},
                    noAd: function(){}
                };
            AdManager.getAdSlot(adPlacement, adUnit, targetingObj, [], adSizes, adPosition, 'in');
        }
    };
});

